export type ConversionStatus =
  | 'checking'
  | 'queued'
  | 'converting'
  | 'ready'
  | 'error';

export interface ConversionItem {
  id: string;
  file: File;
  name: string;
  size: number;
  status: ConversionStatus;
  error?: string;
  outputBlob?: Blob;
  outputUrl?: string;
  outputName?: string;
  outputSize?: number;
  width?: number;
  height?: number;
  qualityUsed?: number;
  retryable?: boolean;
}

export type ConversionAction =
  | { type: 'add'; items: ConversionItem[] }
  | { type: 'patch'; id: string; patch: Partial<ConversionItem> }
  | { type: 'remove'; id: string }
  | { type: 'clear' };

export function conversionReducer(
  state: ConversionItem[],
  action: ConversionAction,
): ConversionItem[] {
  switch (action.type) {
    case 'add':
      return [...state, ...action.items];
    case 'patch':
      return state.map((item) =>
        item.id === action.id ? { ...item, ...action.patch } : item,
      );
    case 'remove':
      return state.filter((item) => item.id !== action.id);
    case 'clear':
      return [];
  }
}

export function summarizeItems(items: ConversionItem[]) {
  return items.reduce(
    (summary, item) => {
      summary[item.status] += 1;
      return summary;
    },
    { checking: 0, queued: 0, converting: 0, ready: 0, error: 0 },
  );
}
